import './App.css';
import Draggable from './Draggable';
import TaskCon from './components/TaskCon';
import 'bootstrap/dist/css/bootstrap.min.css';


function App() {
  return (
    <div className="App">
      <TaskCon />
      {/* <Draggable /> */}
    </div>
  );
}

export default App;
